import { type PropsWithChildren, forwardRef } from "react";

import type { TagProps } from "./Tag.types";
import { cn } from "$/lib/utils/functions/misc.functions";
import CloseIcon from "$/lib/icons/CloseIcon";

const Tag = forwardRef<HTMLDivElement, PropsWithChildren<TagProps>>(
  (
    { label, disabled = false, onRemove, className, ...tagProps },
    forwardedRef,
  ) => {
    return (
      <div
        ref={forwardedRef}
        aria-disabled={disabled}
        className={cn(
          "flex flex-row items-center justify-center gap-2 rounded-full bg-neutral-200 px-3 py-1.5 font-medium text-neutral-900 transition-all duration-200 hover:cursor-default hover:opacity-75 hover:shadow-sm aria-disabled:opacity-50 aria-disabled:hover:cursor-not-allowed aria-disabled:hover:opacity-50",
          { "opacity-50 hover:cursor-not-allowed hover:opacity-50": disabled },
          className,
        )}
        {...tagProps}
      >
        <span>{label}</span>
        {onRemove && (
          <button
            type="button"
            className="flex items-center"
            onClick={onRemove}
          >
            <CloseIcon />
          </button>
        )}
      </div>
    );
  },
);

Tag.displayName = "Tag";

export default Tag;
